import {
  Apple,
  Briefcase,
  Camera,
  Car,
  Cpu,
  Dumbbell,
  Gem,
  GraduationCap,
  HeartPulse,
  Home,
  LayoutDashboard,
  LayoutGrid,
  LayoutTemplate,
  Newspaper,
  Palmtree,
  ShoppingBag,
  Shirt,
  Sparkles,
  Store,
  UtensilsCrossed,
  Wallet,
} from "lucide-react";

export const THEME_ICON_OPTIONS = [
  { id: "layout-grid", label: "Grid" },
  { id: "briefcase", label: "Business" },
  { id: "shopping-bag", label: "E-commerce" },
  { id: "store", label: "Store" },
  { id: "shirt", label: "Fashion" },
  { id: "apple", label: "Grocery" },
  { id: "cpu", label: "Electronics" },
  { id: "heart-pulse", label: "Health" },
  { id: "layout-dashboard", label: "SaaS" },
  { id: "sparkles", label: "Sparkles" },
  { id: "sparkle", label: "Sparkle" },
  { id: "gem", label: "Jewelry" },
  { id: "utensils-crossed", label: "Restaurant" },
  { id: "graduation-cap", label: "Education" },
  { id: "home", label: "Real estate" },
  { id: "dumbbell", label: "Fitness" },
  { id: "camera", label: "Portfolio" },
  { id: "newspaper", label: "Blog" },
  { id: "layout-template", label: "Template" },
  { id: "wallet", label: "Finance" },
  { id: "palmtree", label: "Travel" },
  { id: "car", label: "Auto" },
];

const MAP = {
  apple: Apple,
  briefcase: Briefcase,
  camera: Camera,
  car: Car,
  cpu: Cpu,
  dumbbell: Dumbbell,
  gem: Gem,
  "graduation-cap": GraduationCap,
  "heart-pulse": HeartPulse,
  home: Home,
  "layout-dashboard": LayoutDashboard,
  "layout-grid": LayoutGrid,
  "layout-template": LayoutTemplate,
  newspaper: Newspaper,
  palmtree: Palmtree,
  "shopping-bag": ShoppingBag,
  shirt: Shirt,
  sparkle: Sparkles,
  sparkles: Sparkles,
  store: Store,
  "utensils-crossed": UtensilsCrossed,
  wallet: Wallet,
};

export function isThemeIconUrl(value) {
  const v = String(value || "").trim();
  return v.startsWith("http://") || v.startsWith("https://") || v.startsWith("/api/") || v.startsWith("/media");
}

export function ThemeGlyph({ name, className = "w-5 h-5", alt = "" }) {
  const raw = String(name || "").trim();
  if (isThemeIconUrl(raw)) {
    return <img src={raw} alt={alt} className={`${className} object-contain`} />;
  }
  const Comp = MAP[raw.toLowerCase()] || LayoutGrid;
  return <Comp className={className} />;
}
